import React from 'react';

const Termos = () => (
  <div className="max-w-3xl mx-auto px-6 py-32 text-white">
    <h1 className="text-4xl font-extrabold mb-2">Termos de Uso</h1>
    <p className="text-white/50 text-sm mb-10">Última atualização: maio de 2026</p>

    <p className="text-white/70 leading-relaxed mb-8">
      Ao usar o Anjora, você concorda com estes Termos de Uso. Leia com atenção antes de utilizar o aplicativo.
    </p>

    {[
      {
        title: '1. Sobre o Anjora',
        content: 'O Anjora é um aplicativo de proteção contra apostas online para Android. Ele utiliza o serviço de Acessibilidade do Android para identificar e bloquear conteúdos relacionados a apostas e jogos de azar.'
      },
      {
        title: '2. Uso permitido',
        content: 'O Anjora deve ser usado apenas para fins pessoais e legítimos de proteção contra apostas. É proibido tentar contornar, desativar ou modificar os mecanismos de proteção do aplicativo.'
      },
      {
        title: '3. Assinatura e pagamentos',
        content: 'O Anjora oferece planos semanais (R$9,90), mensais (R$19,90) e anuais (R$99,00). Os pagamentos são processados pela Kiwify. Não há reembolso após a ativação do plano, exceto nos casos previstos pelo Código de Defesa do Consumidor.'
      },
      {
        title: '4. Cancelamento',
        content: 'Você pode cancelar sua assinatura a qualquer momento. O acesso permanece ativo até o fim do período pago. Para cancelar, envie e-mail para suporte@anjora.com.br.'
      },
      {
        title: '5. Limitação de responsabilidade',
        content: 'O Anjora é uma ferramenta de apoio. Não garantimos que todos os conteúdos de apostas serão bloqueados em 100% dos casos. O aplicativo não substitui tratamento médico ou psicológico para dependência em jogos.'
      },
      {
        title: '6. Acessibilidade e permissões',
        content: 'O Anjora requer o serviço de Acessibilidade do Android para funcionar. Essa permissão é usada exclusivamente para identificar e bloquear conteúdo de apostas na tela. Nenhuma informação pessoal é coletada por meio dessa permissão.'
      },
      {
        title: '7. Alterações nos termos',
        content: 'Podemos atualizar estes Termos periodicamente. Você será notificado por e-mail sobre mudanças significativas.'
      },
      {
        title: '8. Contato',
        content: 'Dúvidas: suporte@anjora.com.br'
      }
    ].map((item, i) => (
      <div key={i} className="mb-8">
        <h2 className="text-xl font-bold mb-3 text-blue-400">{item.title}</h2>
        <p className="text-white/70 leading-relaxed">{item.content}</p>
      </div>
    ))}
  </div>
);

export default Termos;
